import { render, staticRenderFns } from "./com-search.vue?vue&type=template&id=71f12c5f"
import script from "./com-search.vue?vue&type=script&lang=js"
export * from "./com-search.vue?vue&type=script&lang=js"
import style0 from "./com-search.vue?vue&type=style&index=0&id=71f12c5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports